import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import {
  useIsAr,
  useQuery,
  useSelectedTheme,
  useTranslate,
} from "../../../../../../../../Hooks";
import {
  CustomMenu,
  PropertyUnitTypeSelectorSkeleton,
} from "../../../../../../../../Components";
import { CloseXIcon, PlusIcon } from "../../../../../../../../assets/icons";
import { useSelector } from "react-redux";
import {
  CreatePropertyUnitType,
  GetAllPropertyUnitTypeAPI,
  lookupItemsGetId,
} from "../../../../../../../../Services";
import { UnitTypes } from "../../../../../../../../Enums";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";

// styles
import useStyle from "./styles";

const PropertyUnitTypeSelector = () => {
  const styles = useStyle();
  const { translate } = useTranslate("NewPropertiesView");
  const theme = useSelector((store) => store.theme);
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { isAr } = useIsAr(theme.themeDirection);
  const query = useQuery();
  const { setAlertBoxContent } = useVerticalNav();
  const [isLoading, setIsLoading] = useState(false);
  const [unitTypesInPropertyList, setUnitTypesInProperty] = useState([]);
  const [propertyUnitTypes, setPropertyUnitTypes] = useState({
    result: [],
    totalCount: 0,
  });
  const getViewsLookups = useCallback(async () => {
    setIsLoading(true);
    const res = await lookupItemsGetId({
      lookupTypeId: UnitTypes.lookupTypeId,
    });
    if (!(res && res.status && res.status !== 200)) {
      setUnitTypesInProperty(res);
    } else setUnitTypesInProperty([]);

    setIsLoading(false);
  }, []);
  const addDeleteUnitTypeHandler = async ({
    addOpration = false,
    unitType,
  }) => {
    let res;
    try {
      setIsLoading(true);
      if (addOpration) {
        res = await CreatePropertyUnitType({
          propertyId: query.get("id"),
          propertyUnitType: [
            ...propertyUnitTypes.result,
            {
              lookupItemName: unitType?.lookupItemName,
              lookupItemId: unitType?.lookupItemId,
            },
          ],
        });
      } else {
        res = await CreatePropertyUnitType({
          propertyId: query.get("id"),
          propertyUnitType: propertyUnitTypes?.result,
        });
      }
      if (!(res && res.status && res.status !== 200)) {
        setAlertBoxContent({
          display: true,
          variant: "success",
          title: addOpration
            ? translate("PropertyUnitTypes-created-successfully")
            : translate("PropertyUnitTypes-deleted-successfully"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
        GetAllPropertyUnitType();
      } else {
        setAlertBoxContent({
          display: true,
          variant: "error",
          title: addOpration
            ? translate("PropertyUnitTypes-created-failed")
            : translate("PropertyUnitTypes-deleted-failed"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
      }
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: addOpration
          ? translate("PropertyUnitTypes-created-failed")
          : translate("PropertyUnitTypes-deleted-failed"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteUnitTypeHandler = (deleteUnitTypeById) => {
    const updatedUnitTypes = propertyUnitTypes.result.filter(
      (unitType) => unitType.lookupItemId !== deleteUnitTypeById
    );
    propertyUnitTypes.result = updatedUnitTypes;
    addDeleteUnitTypeHandler({ addOpration: false, unitType: null });
  };

  const GetAllPropertyUnitType = useCallback(async () => {
    const res = await GetAllPropertyUnitTypeAPI(query.get("id"));
    if (!(res && res.status && res.status !== 200)) {
      setPropertyUnitTypes({
        result: (res && res[0] && res[0].propertyUnitType) || [],
        totalCount: (res && res.totalCount) || 0,
      });
    } else {
      setPropertyUnitTypes({
        result: [],
        totalCount: 0,
      });
    }
  }, []);

  const filterOptionMnue = () => {
    const propertyUnitTypeIds = propertyUnitTypes?.result?.map(
      (item) => item?.lookupItemId
    );
    const filteredUnitTypes = unitTypesInPropertyList?.filter(
      (unit) => !propertyUnitTypeIds?.includes(unit.lookupItemId)
    );

    return filteredUnitTypes;
  };

  const getIconUnitType = () => {};

  useEffect(() => {
    getViewsLookups();
    GetAllPropertyUnitType();
  }, []);

  useEffect(() => {
    filterOptionMnue();
  }, [propertyUnitTypes]);

  return (
    <Box className={styles.containerUnitSelector}>
      {isLoading ? (
        <PropertyUnitTypeSelectorSkeleton />
      ) : (
        <>
          <Typography className={styles.titleUnitType}>
            {translate("Units-type")}
          </Typography>
          <Box className={styles.containerSelectedUnitType}>
            {propertyUnitTypes.result.map((selectedUnitType, index) => (
              <Box className={styles.containerUnitType} key={index}>
                <Typography className={styles.selectedUnitTypeTitle}>
                  {selectedUnitType?.lookupItemName}
                </Typography>
                <CloseXIcon
                  onClick={() => {
                    deleteUnitTypeHandler(selectedUnitType?.lookupItemId);
                  }}
                  width="20"
                  height="20"
                  fill={palette.foreground.quinary}
                />
              </Box>
            ))}
            {filterOptionMnue().length > 0 && (
              <Box className={styles.wrapperAddUnitButton}>
                <CustomMenu
                  menuItems={
                    filterOptionMnue()?.map((unitType) => ({
                      text: `${unitType?.lookupItemName || ""}`,
                      icon: getIconUnitType(),
                      handler: () => {
                        addDeleteUnitTypeHandler({
                          addOpration: true,
                          unitType: unitType,
                        });
                      },
                    })) || []
                  }
                  activeIconClass={styles.menuActiveIconClass}
                  defaultIconClass={styles.menuDefaultIconClass}
                  customAnchorOrigin={{
                    vertical: "bottom",
                    horizontal: isAr ? "right" : "left",
                  }}
                  customTransformOrigin={{
                    vertical: "top",
                    horizontal: isAr ? "right" : "left",
                  }}
                >
                  <PlusIcon
                    width="20"
                    height="20"
                    fill={palette.button.secondary_fg}
                  />
                </CustomMenu>
              </Box>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};
export default PropertyUnitTypeSelector;
